import { createFileRoute } from "@tanstack/react-router";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";
import { PurchaseOrderForm } from "@/components/purchase-orders/purchase-order-form";
import { Id } from "@/convex/_generated/dataModel";

export const Route = createFileRoute(
  "/_authenticated/purchase-orders/$id/edit",
)({
  component: EditPurchaseOrderPage,
});

function EditPurchaseOrderPage() {
  const { id } = Route.useParams();

  return (
    <RouteGuardPermissions
      permissions={[{ module: "purchase_orders", actions: ["read", "update"] }]}
    >
      <PurchaseOrderForm purchaseOrderId={id as Id<"purchase_orders">} />
    </RouteGuardPermissions>
  );
}
